import ff from './ff';

export default class c10d {

static d_defs = {

/*
  DROP TABLE t_c10r;
  CREATE TABLE t_c10r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER,
    c10rb01k INTEGER,
    c10rb21f INTEGER,
    c10rb31f INTEGER,
    c10rc01s TEXT,
    c10rc02s TEXT,
    c10rc11s TEXT,
    c10rc31s TEXT,
    c10rc32s TEXT,
    c10rc33s TEXT,
    c10ri11s TEXT,
    c10rt11i INTEGER,
    c10rcx1i INTEGER,
    c10rcy1t TEXT,
    c10rcy1f INTEGER,
    c10rcz1i INTEGER
    , CONSTRAINT c10r_unq1 UNIQUE (c10rb21f, c10rb31f, c10rc11s)
  );
  INSERT INTO t_c10r (_vsn, _ltt, c10rb01k, c10rb21f, c10rc01s, c10rc02s, c10rc11s, c10rc31s, c10ri11s, c10rt11i, c10rcy1t, c10rcy1f, c10rcz1i) 
  VALUES (1, 1, 1, 0, 'kanri1', '519832', '1', 'test-kanri1', 'yko.bear.1975@gmail.com', 90, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c10r (_vsn, _ltt, c10rb01k, c10rb21f, c10rc01s, c10rc02s, c10rc11s, c10rc31s, c10ri11s, c10rt11i, c10rcy1t, c10rcy1f, c10rcz1i) 
  VALUES (1, 1, 2, 1, 'dantai1', '519832', '0-0001', '〇〇クラブ', '団体1', 10, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c10r (_vsn, _ltt, c10rb01k, c10rb21f, c10rc01s, c10rc02s, c10rc11s, c10rc31s, c10ri11s, c10rt11i, c10rcy1t, c10rcy1f, c10rcz1i) 
  VALUES (1, 1, 3, 1, 'staff1', '519832', '1', 'test-staff1', 'スタッフ1', 20, '2000-01-01 00:00:00', 1, 10);
  UPDATE t_c10r SET _fst = _key;
*/

  c10r: {
    0: {
      pfx: '利用者情報',
      b_vsn: false, // 歴管理の対象外
      dd_fldDefss: {
        c10rb01k: { // 必要？
          pfx: 'c00r_key',
          type: 'Inp',
        },
        c10rb21f: {
          pfx: 'c20r_fst',
          type: 'Inp',
        },
        c10rb31f: {
          pfx: 'c30r_fst',
          type: 'Inp',
        },
        c10rc01s: {
          pfx: 'ログインID',
          type: 'Inp',
          lo_qrys: [ // スタッフ用アカウントの追加
            _d_vals => {
              let _qry =     `
                INSERT INTO
                  t_c10r
                (
                  c10rb21f,
                  c10rb31f,
                  c10rc11s,
                  c10rc31s,
                  c10rc01s,
                  c10rc02s,
                  c10rt11i
                ) VALUES (
                  ${_d_vals.c10rb21f},
                  -2,
                  "999999999999",
                  "cs-admin",
                  "${_d_vals.c10rc01s}",
                  "${_d_vals.c10rc02s}",
                  20
                )
                ON CONFLICT ON CONSTRAINT c10r_unq1
                DO UPDATE SET
                  c10rc01s = "${_d_vals.c10rc01s}"
                  , c10rc02s = "${_d_vals.c10rc02s}"
                WHERE   
                  t_c10r.c10rb21f = ${_d_vals.c10rb21f}
                  AND t_c10r.c10rb31f = -2
                  AND t_c10r.c10rc11s = "999999999999"
                ;
              `;
              return _qry;
            },
            _d_vals => { // 役割
              let _qry = `
                INSERT INTO 
                  t_c41r
                (
                  _vsn, 
                  _ltt, 
                  c41rb21f, 
                  c41rc11s, 
                  c41rc31s
                ) VALUES (
                  1, 
                  1, 
                  ${_d_vals.c10rb21f}, 
                  "999999999999", 
                  "管理者"
                )
                ON CONFLICT ON CONSTRAINT c41r_unq1
                DO NOTHING
                ;
              `;
              return _qry;
            },            
            _d_vals => {
              let _qry = `
                UPDATE 
                  t_c41r 
                SET 
                  _fst = _key
                WHERE
                  c41rb21f = ${_d_vals.c10rb21f}
                  AND c41rc11s = "999999999999"
                  AND _vsn = 1
                ;
              `;
              return _qry;
            },            
            _d_vals => { // 役割別機能
              let _qry = `
                INSERT INTO
                  t_c410 
                (
                  _vsn, 
                  _ltt, 
                  c410b21f, 
                  c410b41k, 
                  c410b51k
                ) VALUES (
                  1, 
                  1, 
                  ${_d_vals.c10rb21f},
                  11, 
                  (SELECT _key FROM t_c41r WHERE c41rb21f = ${_d_vals.c10rb21f} AND c41rc11s="999999999999" AND _vsn = 1)
                )
                ON CONFLICT ON CONSTRAINT c410_unq1
                DO NOTHING
                ;
              `;
              return _qry;
            },            
            _d_vals => {
              let _qry = `
                INSERT INTO
                  t_c410 
                (
                  _vsn, 
                  _ltt, 
                  c410b21f, 
                  c410b41k, 
                  c410b51k
                ) VALUES (
                  1, 
                  1, 
                  ${_d_vals.c10rb21f},
                  12, 
                  (SELECT _key FROM t_c41r WHERE c41rb21f = ${_d_vals.c10rb21f} AND c41rc11s="999999999999" AND _vsn = 1)
                )
                ON CONFLICT ON CONSTRAINT c410_unq1
                DO NOTHING
                ;
              `;
              return _qry;
            },            
            _d_vals => {
              let _qry = `
                INSERT INTO
                  t_c410 
                (
                  _vsn, 
                  _ltt, 
                  c410b21f, 
                  c410b41k, 
                  c410b51k
                ) VALUES (
                  1, 
                  1, 
                  ${_d_vals.c10rb21f},
                  13, 
                  (SELECT _key FROM t_c41r WHERE c41rb21f = ${_d_vals.c10rb21f} AND c41rc11s="999999999999" AND _vsn = 1)
                )
                ON CONFLICT ON CONSTRAINT c410_unq1
                DO NOTHING
                ;
              `;
              return _qry;
            },            
            _d_vals => {
              let _qry = `
                INSERT INTO
                  t_c410 
                (
                  _vsn, 
                  _ltt, 
                  c410b21f, 
                  c410b41k, 
                  c410b51k
                ) VALUES (
                  1, 
                  1, 
                  ${_d_vals.c10rb21f},
                  14, 
                  (SELECT _key FROM t_c41r WHERE c41rb21f = ${_d_vals.c10rb21f} AND c41rc11s="999999999999" AND _vsn = 1)
                )
                ON CONFLICT ON CONSTRAINT c410_unq1
                DO NOTHING
                ;
              `;
              return _qry;
            },            
            _d_vals => {
              let _qry = `
                UPDATE 
                  t_c410
                SET 
                  _fst = _key
                WHERE
                  c410b21f = ${_d_vals.c10rb21f}
                  AND c410b51k = (SELECT _key FROM t_c41r WHERE c41rb21f = ${_d_vals.c10rb21f} AND c41rc11s="999999999999" AND _vsn = 1)
                ;
              `;
              return _qry;
            },            
            _d_vals => { // スタッフ別担当
              let _qry = `
                INSERT INTO 
                  t_c42r 
                (
                  _vsn, 
                  _ltt, 
                  c42rb21f, 
                  c42rb11k
                ) 
                VALUES (
                  1, 
                  1, 
                  ${_d_vals.c10rb21f}, 
                  (SELECT _key from t_c10r WHERE c10rb21f = ${_d_vals.c10rb21f} AND c10rb31f = -2 AND c10rc11s = "999999999999")
                )
                ON CONFLICT ON CONSTRAINT c42r_unq1
                DO NOTHING
                ;
              `;
              return _qry;
            },            
            _d_vals => {
              let _qry = `
                UPDATE 
                  t_c42r
                SET 
                  _fst = _key
                WHERE
                  c42rb21f = ${_d_vals.c10rb21f}
                  AND c42rb11k = (SELECT _key from t_c10r WHERE c10rb21f = ${_d_vals.c10rb21f} AND c10rb31f = -2 AND c10rc11s = "999999999999")
                ;
              `;
              return _qry;
            },            
            _d_vals => {
              let _qry = `
                INSERT INTO 
                  t_c420 
                (
                  _vsn, 
                  _ltt, 
                  c420b21f, 
                  c420b61k, 
                  c420b51f
                ) VALUES (
                  1, 
                  1, 
                  ${_d_vals.c10rb21f}, 
                  (SELECT _key FROM t_c42r WHERE c42rb21f = ${_d_vals.c10rb21f} AND c42rb11k = (SELECT _key from t_c10r WHERE c10rb21f = ${_d_vals.c10rb21f} AND c10rb31f = -2 AND c10rc11s = "999999999999")),
                  (SELECT _key FROM t_c41r WHERE c41rb21f = ${_d_vals.c10rb21f} AND c41rc11s="999999999999" AND _vsn = 1)
                )
                ON CONFLICT ON CONSTRAINT c420_unq1
                DO NOTHING
                ;
              `;
              return _qry;
            },            

            _d_vals => {
              let _qry = `
                UPDATE 
                  t_c420
                SET 
                  _fst = _key
                WHERE
                  c420b21f = ${_d_vals.c10rb21f}
                  AND c420b61k = (SELECT _key FROM t_c42r WHERE c42rb21f = ${_d_vals.c10rb21f} AND c42rb11k = (SELECT _key from t_c10r WHERE c10rb21f = ${_d_vals.c10rb21f} AND c10rb31f = -2 AND c10rc11s = "999999999999"))
                ;
              `;
              return _qry;
            },            

            _d_vals => {
              let _qry = `
                INSERT INTO 
                  t_c51r 
                (
                  _vsn, 
                  _ltt, 
                  c51rb21f, 
                  c51rc11s, 
                  c51ri11s
                ) 
                SELECT  
                  1, 
                  1, 
                  ${_d_vals.c10rb21f}, 
                  c50rc11s, 
                  c50ri21s
                FROM
                  t_c50r                
                ON CONFLICT ON CONSTRAINT c51r_unq1
                DO NOTHING    
                ;
              `;
              return _qry;
            },            

            _d_vals => {
              let _qry = `
                UPDATE 
                  t_c51r
                SET 
                  _fst = _key
                WHERE
                  c51rb21f = ${_d_vals.c10rb21f}
                  AND _vsn = 1
                ;
              `;
              return _qry;
            },            
          ],
        },
        c10rc02s: {
          pfx: 'パスワード',
          type: 'Inp',
          b_pwd: true,
          o_stlVal: _d_dats => {
            return ff.myCM_pdd('', ff.myCM_getLen(_d_dats.d_flds.c10rc02s), '●')
          }
        },
        c10rc11s: {
//          pfx: 'ID',
          pfx: 'スタッフID',
          type: 'Inp',
          n_col: 6,
        },
        c10rc31s: {
//          pfx: '表記',
          pfx: 'スタッフ名',
          type: 'Inp',
          n_col: 15,
        },
        c10rc32s: {
          pfx: '正式名',
          type: 'Inp',
        },
        c10rc33s: {
          pfx: 'よみがな',
          type: 'Inp',
        },
        c10ri11s: {
          pfx: 'メールアドレス',
          type: 'Inp',
          n_col: 20,
          lo_qrys: [ // 団体用アカウントの追加
            _d_vals => { // 同一のメールアドレスで、複数の c10rb21f, c10rb31f, c10rc11s を利用する場合を考慮
              let _qry =     `
                INSERT INTO
                  t_c10r
                (
                  c10rb21f,
                  c10rb31f,
                  c10rc11s,
                  c10ri11s,
                  c10rt11i
                ) VALUES (
                  ${global.t?.state.sgcd_cmnStgs.c20r_fst},
                  ${_d_vals.c10rb31f},
                  "${_d_vals.c10rc11s}",
                  "${_d_vals.c10ri11s}",
                  10
                )
                ON CONFLICT ON CONSTRAINT c10r_unq1
                DO UPDATE SET
                  c10ri11s = "${_d_vals.c10ri11s}"
                WHERE
                  COALESCE(t_c10r.c10rcz1i, 10) <> 0
                  AND t_c10r.c10rb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                  AND t_c10r.c10rb31f = ${_d_vals.c10rb31f}
                  AND t_c10r.c10rc11s = "${_d_vals.c10rc11s}"
              `;
              return _qry;
            },
          ],
        },
        c10rt11i: {
          pfx: '利用者区分',
          type: 'Pck',
          ld_iss: [
            { key: 10, pfx: '団体'},
            { key: 20, pfx: 'スタッフ'}, // スタッフは団体メンバとなることもありえる
            { key: 90, pfx: '管理'}
          ],
        },
      },
    }
  },

/*
  DROP TABLE t_c100;
  CREATE TABLE t_c100 (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER,
    c100b11k INTEGER,
    c100b21f INTEGER,
    c100bk1f INTEGER,
    c100c11s TEXT,
    c100c12s TEXT,
    c100c31s TEXT,
    c100c33s TEXT,
    c100i11s TEXT,
    c100i13s TEXT,
    c100i21s TEXT,
    c100i22i TEXT,
    c100i31s TEXT,
    c100i32s TEXT,
    c100i33s TEXT,
    c100i34s TEXT,
    c100i41s TEXT,
    c100i42s TEXT,
    c100t21i INTEGER,
    c100i21i INTEGER,
    c100t22i INTEGER,
    c100i51s TEXT,
    c100i52s TEXT, 
    c100i53s TEXT,
    c100i61s TEXT,
    c100i71d TEXT,
    c100i71s TEXT,
    c100i81s TEXT,
    c100i91i INTEGER,
    c100i92i INTEGER,
    c100i93i INTEGER,
    c100i94i INTEGER,
    c100ia1i INTEGER,
    c100ib1i INTEGER,
    c100ic1s TEXT,
    c100id1s TEXT,
    c100id2s TEXT,
    c100ie1i INTEGER,
    c100ie2s TEXT,
    c100ie3i INTEGER,
    c100ie4i INTEGER,
    c100ie5i INTEGER,
    c100if1i INTEGER,
    c100if1m BIGINT,
    c100cx1i INTEGER,
    c100cy1t TEXT,
    c100cy1f INTEGER,
    c100cz1i INTEGER
  );
  INSERT INTO t_c100 (_vsn, _ltt, c100b11k, c100b21f, c100bk1f, c100c11s, c100c12s, c100c31s, c100c33s, c100i11s, c100i13s, c100i21s, c100t21i, c100i21i, c100t22i, c100cx1i, c100cy1t, c100cy1f, c100cz1i) 
  VALUES (1, 1, 2, 1, 1, '0-0001', '0001', '○○クラブ', 'まるまるくらぶ', '丸川大輔', 'まるかわだいすけ', 'なし', 50, 50, 10, 9999, '2000-01-01 00:00:00', 1, 10);
  UPDATE t_c100 SET _fst = _key;
*/

  c100: {
    0: {
      pfx: '団体情報',
      b_vsn: true,
      d_insFlds: {
        c10rc31s: '',
        c100c11s: '',
        c100c31s: '',
        c100c33s: '',
        c100i11s: '',
        c100i13s: '',
        c100i21s:  0,
        c100t21i:  0,
        c100t22i: -1,
        c100i31s: '',
        c100i32s: '',
        c100i33s: '',
        c100i34s: '',
        c100i41s: '',
        c100i42s: '',
        c100i51s: '',
        c100i52s: '',
      },
      dd_fldDefss: {
        c100b11k: { // c10r_key
//          pfx: 'c10r_key',
//          type: 'Inp',
          pfx: '団体',
          type: 'PckSch',
          n_col: 15,
        },
        c100b21f: {
          pfx: 'c20r_fst',
          type: 'Inp',
        },
        c100bk1f: { 
          pfx: '団体種別',
          type: 'Pck',
          n_col: 3,
          b_rqr: true,
        },
/*
        c100c11s: {
          pfx: '団体番号',
          type: 'Inp',
          n_col: 6,
          b_rqr: true,
        },
*/
        c100c12s: {
          pfx: '団体コード',
          type: 'Inp',
          n_col: 5,
          b_rqr: true,
        },
        c100c31s: {
          pfx: '団体名',
          type: 'Inp',
          n_col: 15,
          b_rqr: true,
        },
        c100c33s: {
          pfx: '団体名かな',
          type: 'Inp',
          n_col: 15,
        },
        c100i11s: {
          pfx: '代表者名',
          type: 'Inp',
          n_col: 10,
        },
        c100i13s: {
          pfx: '代表者名かな',
          type: 'Inp',
          n_col: 10,
        },
        c100i21s: {
          pfx: '利用制限',
          type: 'Pck',
          ld_iss: [
            { key:  -1, pfx: ' ' },
            { key:   0, pfx: 'なし' },
            { key:  10, pfx: 'WEB予約・エントリー利用を制限' },
          ],
          n_col: 20,
        },
        c100t21i: {
          pfx: '減免率区分',
          type: 'Pck',
          ld_iss: [
            { key:  -1, pfx: ' ' },
            { key:   0, pfx: 'なし' },
            { key:  50, pfx: '50%' },
            { key: 100, pfx: '100%' },
            { key: 999, pfx: '任意' },
          ],
          n_col: 5,
        },
        c100i22i: {
          pfx: '減免率',
          type: 'Inp',
          n_col: 5,
        },
        c100t22i: {
          pfx: '減免理由区分',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: 'A' },
            { key: 20, pfx: 'B' },
            { key: 30, pfx: 'C' },
            { key: 40, pfx: 'D' },
          ],
          n_col: 5,
        },

        c100i31s: {
          pfx: '郵便番号',
          type: 'Inp',
          n_col: 6,
        },
        c100i32s: {
          pfx: '都道府県',
          type: 'Inp',
          n_col: 5,
        },
        c100i33s: {
          pfx: '市町番地',
          type: 'Inp',
          n_col: 15,
        },
        c100i34s: {
          pfx: '建物・フロア等',
          type: 'Inp',
          n_col: 15,
        },
        c100i41s: {
          pfx: '電話(主)',
          type: 'Inp',
          n_col: 10,
        },
        c100i42s: {
          pfx: '電話(副)',
          type: 'Inp',
          n_col: 10,
        },
        c100i51s: { 
          pfx: 'メール(主)',
          type: 'Inp',
          n_col: 15,
          b_rqr: true,
        },
        c100i52s: { 
          pfx: 'メール(副)',
          type: 'Inp',
          n_col: 15,
          b_rqr: true,
        },
        c100i53s: { 
          pfx: 'メール(副)',
          type: 'Inp',
          n_col: 15,
          b_rqr: true,
        },
        c100i61s: { 
          pfx: 'パスワード',
          type: 'Inp',
          n_col: 10,
          b_rqr: true,
        },
        c100i71d: { 
          pfx: '次回更新日',
          type: 'PckDate',
        },
        c100i71s: { 
          pfx: '更新メモ',
          type: 'Inp',
          b_mln: true,
          n_col: 15,
        },
        c100i81s: { 
          pfx: '備考',
          type: 'Inp',
          b_mln: true,
          n_col: 20,
        },
        c100i91i: { 
          pfx: '活動頻度区分',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: '月' },
            { key: 20, pfx: '年' },
          ],
          n_col: 5,
        },
        c100i92i: { 
          pfx: '活動頻度回数',
          type: 'Inp',
          n_col: 5,
        },
        c100i93i: { 
          pfx: '活動時間帯',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: '午前' },
            { key: 20, pfx: '午後' },
            { key: 30, pfx: '夜間' },
            { key: 90, pfx: 'その他' },
          ],
          n_col: 5,
        },
        c100i94i: { 
          pfx: '活動曜日',
          type: 'Inp',
          n_col: 15,
        },
        c100ia1i: { 
          pfx: '会員募集',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: 'する' },
            { key:  0, pfx: 'しない' },
          ],
          n_col: 5,
        },
        c100ib1i: { 
          pfx: 'カテゴリ',
          type: 'Pck',
          n_col: 10,
        },
        c100ic1s: { 
          pfx: '活動内容',
          type: 'Inp',
          b_mln: true,
          n_col: 20,
        },
        c100id1s: { 
          pfx: '指導者名',
          type: 'Inp',
        },
        c100id2s: { 
          pfx: '指導者名かな',
          type: 'Inp',
        },
        c100ie1i: { 
          pfx: '会員構成分類区分',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: '一般' },
            { key: 20, pfx: '事後サークル' },
            { key: 30, pfx: '優先団体' },
            { key: 90, pfx: 'その他' },
          ],
          n_col: 10,
        },
        c100ie2s: { 
          pfx: '会員構成分類その他',
          type: 'Inp',
          n_col: 10,
        },
        c100ie3i: { 
          pfx: '会員構成人数男性',
          type: 'Inp',
          n_col: 5,
        },
        c100ie4i: { 
          pfx: '会員構成人数女性',
          type: 'Inp',
          n_col: 5,
        },
        c100ie5i: { 
          pfx: '会員構成人数こども',
          type: 'Inp',
          n_col: 5,
        },
        c100if1i: { 
          pfx: '会費分類',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 20, pfx: '一ヶ月あたり' },
            { key: 10, pfx: '一回あたり' },
          ],
        },
        c100if1m: { 
          pfx: '会費料金',
          type: 'Inp',
          n_col: 5,
        },
      },
    }
  },

};

};
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
